import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Hero = () => {
  const { t } = useLang();
  if (!t) return null;
  const h = t.hero;

  return (
    <section id="accueil" className="ledger-bg relative overflow-hidden" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-24 md:pt-28 md:pb-32 grid gap-14 md:grid-cols-[1.15fr_0.85fr] items-center">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-rouge font-medium">
            <span className="h-px w-8 bg-rouge" />
            {h.eyebrow}
          </span>
          <h1 className="fluid-h1 mt-6 text-noir">
            {h.title_pre}{" "}
            <em className="italic text-rouge font-normal">{h.title_em}</em>{" "}
            {h.title_post}
          </h1>
          <p className="mt-7 text-lg md:text-xl text-gris max-w-xl leading-relaxed">{h.lead}</p>

          <div className="mt-9 flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid="hero-primary-btn"
              className="group inline-flex items-center gap-2 rounded-full bg-rouge px-7 py-3.5 text-sm text-white hover:bg-[#c5291a] transition-colors duration-200"
            >
              {h.btn_primary}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#services"
              data-testid="hero-ghost-btn"
              className="inline-flex items-center rounded-full border border-noir/25 px-7 py-3.5 text-sm text-noir hover:border-noir hover:bg-noir hover:text-creme transition-colors duration-200"
            >
              {h.btn_ghost}
            </a>
          </div>
        </div>

        <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
          <div
            className="relative rounded-2xl bg-noir text-creme p-8 md:p-10 overflow-hidden grain"
            style={{ backgroundImage: "radial-gradient(120% 120% at 80% 0%, #2a241d 0%, #191613 55%)" }}
          >
            <div className="absolute -top-16 -right-16 h-48 w-48 rounded-full bg-rouge/20 blur-2xl" />
            <p className="text-xs uppercase tracking-[0.25em] text-or relative">KHuma</p>
            <div className="mt-8 space-y-7 relative">
              {h.stats.map((s, i) => (
                <div key={s.label || i} className="border-b border-creme/10 pb-6 last:border-0 last:pb-0">
                  <div className="font-serif text-4xl md:text-5xl text-creme">{s.value}</div>
                  <div className="mt-1 text-sm text-creme/55">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
